<template>
  <div>
    <tiger-category-strip name="よくある質問の利用方法" :items="categoryLinks" />
    <div class="search">
      <input v-model="keyword" type="search" aria-label="よくある質問を検索" placeholder="質問を検索（例：入金、パスワード）">
    </div>
    <div class="count">
      {{ countText }}
    </div>
    <section v-for="category in filteredCategories" :id="category.id" :key="category.id" class="section faq-category">
      <div class="sectionheading">
        <h2>{{ category.title }}</h2>
      </div>
      <div class="folds">
        <article v-for="item in category.items" :key="item.q" class="qa-item">
          <div class="question">
            <span class="qicon">Q</span>{{ item.q }}
          </div>
          <div class="answer" v-text="item.a" />
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import TigerCategoryStrip from './tigerCategoryStrip.vue'

const faqCategories = [
  {
    id: 'category-1',
    title: 'ご登録・ご利用について',
    items: [
      {
        q: 'Tiger casinoへの登録方法は？',
        a: '「新規登録」をクリックし、必要事項を入力すると登録が完了します。'
      },
      {
        q: '利用可能なデバイスは？',
        a: 'Tiger casinoではスマートフォン、タブレット、PCに対応しています。いつでもどこでもお楽しみいただけます。'
      },
      {
        q: '使用できる通貨は？',
        a: '7種類の仮想通貨で入出金が可能です。\nTiger casinoでは、以下の仮想通貨での入出金に対応しております：\nBTC（ビットコイン）\nETH（イーサリアム）\nLTC（ライトコイン）\nSOL（ソラナ）\nUSDT（テザー）\nXRP（リップル）\nTRX（トロン）'
      },
      {
        q: '年齢制限はありますか？',
        a: 'Tiger Casinoのご利用は、20歳以上の方に限られます。'
      },
      {
        q: 'アカウントはいくつ作成できますか？',
        a: 'Tiger Casinoでは、原則としてお一人様につき1アカウントのみ登録できます。同一人物、同一世帯、同一IP、同一端末、または関連性が疑われる複数アカウントが確認された場合、当社の判断により一部または全部のアカウントを停止・閉鎖し、関連するベット、ボーナス、賞金を無効とする場合があります。'
      },
      {
        q: '自宅以外のPCから利用できますか？',
        a: 'はい、ご利用いただけます。\nただし、公共のPCや他人が利用する端末でログインする場合は、アカウント情報の取り扱いに十分ご注意ください。\n万一お客様のアカウントが不正に使用された場合、その損害についてTiger Casinoは責任を負いかねますので、あらかじめご了承ください。'
      },
      {
        q: '登録した個人情報は変更できますか？',
        a: 'ご登録いただいた個人情報は、お客様ご自身で変更することはできません。\n変更が必要な場合は、カスタマーサポートまでお問い合わせください。'
      },
      {
        q: 'ライブチャットが利用できません。どうすれば良いですか？',
        a: '一時的に接続が不安定な可能性があります。時間をおいて再度お試しください。\n解決しない場合は「support@tiger-casinos.com」までメールでご連絡ください。'
      },
      {
        q: 'カスタマーサポートの対応時間は？',
        a: 'Tiger Casinoでは、日本語対応のライブチャットを日本時間16時〜翌1時までご利用いただけます。チャットサポート時間外はメール「support@tiger-casinos.com」にてご連絡ください。'
      }
    ]
  },
  {
    id: 'category-2',
    title: 'ログイン・アカウントについて',
    items: [
      {
        q: 'ログインできません。どうすれば良いですか？',
        a: 'ご入力いただいたユーザー名とパスワードが正しいかを再度ご確認ください。\n解決しない場合は、カスタマーサポートまでお問い合わせください。'
      },
      {
        q: 'メールアドレスはどのように変更できますか？',
        a: '「メールアドレス変更希望」と明記のうえ、以下の情報をライブチャットまたはメール「support@tiger-casinos.com」までご連絡ください。\nユーザー名\n氏名\n変更理由\n古いメールアドレス\n新しいメールアドレス'
      },
      {
        q: 'パスワードは変更できますか？',
        a: 'はい、可能です。ログイン後に「アカウント認証」ページ内の「個人情報」欄にある「パスワード設定」から変更できます。'
      },
      {
        q: 'パスワードを忘れた場合は、どうすれば良いですか？',
        a: 'ログイン画面の「パスワードをお忘れ」をクリックし、ユーザー名とメールアドレスを入力すると、パスワードを再設定できます。'
      },
      {
        q: 'ユーザー名を忘れた場合は、どうすれば良いですか？',
        a: '「ユーザー名を忘れた」と明記のうえ、以下の情報をライブチャットまたはメール「support@tiger-casinos.com」までご連絡ください。\n氏名\nメールアドレス\n電話番号'
      },
      {
        q: 'ユーザー名を変更できますか？',
        a: 'ユーザー名は登録完了後に変更することはできません。'
      },
      {
        q: 'メール配信を停止できますか？',
        a: 'はい、可能です。「メール配信の停止希望」と明記のうえ、以下の情報をライブチャットまたはメール「support@tiger-casinos.com」までご連絡ください。\nユーザー名\n氏名\nメールアドレス'
      },
      {
        q: 'アカウントを退会または凍結はできますか？',
        a: 'はい、可能です。「アカウント退会・凍結希望」と明記の上、以下の情報をカスタマーサポートまでメールまたはチャットにてご連絡ください。手続きが完了するとログインやメールの受信はできなくなります。\nユーザー名\n氏名\nメールアドレス'
      },
      {
        q: 'アカウントを削除できますか？',
        a: 'Tiger Casinoでは、お一人様につき1アカウントのみご利用いただけるため、アカウントの削除はできません。'
      }
    ]
  },
  {
    id: 'category-3',
    title: '入金について',
    items: [
      {
        q: 'どのような入金方法がありますか？',
        a: '入金方法は仮想通貨のみ対応しています。'
      },
      {
        q: '1回あたりの入金額はいくらですか？',
        a: '原則として最低入金額は5000円からとなります。'
      },
      {
        q: '入金にかかる時間はどれくらいですか？',
        a: '仮想通貨での入金は、原則として即時〜10分以内に反映されます。'
      },
      {
        q: '入金時に手数料はかかりますか？',
        a: 'Tiger Casinoでは、入出金時の手数料は一切発生いたしません。なお、ご利用の取引所またはウォレットよっては取引所の方で手数料が発生する場合がございます。'
      },
      {
        q: '入金時間に制限はありますか？',
        a: '制限はございません。365日24時間いつでもご入金いただけます。'
      }
    ]
  },
  {
    id: 'category-4',
    title: '出金について',
    items: [
      {
        q: 'どのような出金方法がありますか？',
        a: 'ご出金は仮想通貨のみ対応しています。'
      },
      {
        q: '最低・最大出金額はいくらですか？',
        a: '最低出金額：6000円\n1日最大出金額：1,500,000円'
      },
      {
        q: '出金にかかる時間はどれくらいですか？',
        a: '通常は数分〜15分ほどで出金が完了します。ただし、決済プロバイダーやブロックチェーンの混雑状況によっては、処理に時間がかかる場合があります。'
      },
      {
        q: '出金時に手数料はかかりますか？',
        a: 'Tiger Casinoでは、入出金時の手数料は一切発生いたしません。'
      },
      {
        q: '出金時間に制限はありますか？',
        a: '制限はございません。365日24時間対応しています。なお出金額によって通常よりお時間がかかる場合がございます。'
      },
      {
        q: '入金後すぐに出金できますか？',
        a: 'マネーロンダリングなどの不正送金防止のため、入金直後の出金はできません。ゲーム結果に関わらず、入金額の「１倍」をベットいただく必要があります。この条件を満たした上で、出金が可能となります。'
      },
      {
        q: 'ボーナスの賭け条件をクリアーしたけど出金出来ません。',
        a: 'ボーナスの賭け条件・出金条件を達成しても、自動でリアルマネーには移行されません。出金するには、「ウォレット振替」からボーナスウォレットの残高をご自身でメインウォレットまたは対応する仮想通貨ウォレットへ移行してください。その後、移行先のウォレットから出金申請を行ってください。'
      },
      {
        q: 'ウォレット振替（スワップ機能）には手数料掛かりますか？',
        a: '手数料はかかりませんがスワップレートは随時変動する為、スプレッドにより換金額は変わります。'
      }
    ]
  },
  {
    id: 'category-5',
    title: 'ゲームについて',
    items: [
      {
        q: '各ゲームの最低ベット額はいくらですか？',
        a: 'ゲームによって異なります。各ゲーム内でご確認ください。'
      },
      {
        q: 'プレイ記録はどこで確認できますか？',
        a: 'アカウント内の「ゲーム履歴」から確認できます。'
      },
      {
        q: 'ゲームが開けません。どうすれば良いですか？',
        a: '以下をお試しください。\nブラウザのキャッシュ・クッキーを削除\n他のブラウザで起動（Chrome推奨）\nデバイスのOSやブラウザを最新に更新\n再起動後に再試行\n解決しない場合はスクリーンショットを添付し、サポートへご連絡ください。'
      }
    ]
  }
]

export default {
  name: 'TigerFaq',
  components: {
    TigerCategoryStrip
  },
  data() {
    return {
      keyword: ''
    }
  },
  computed: {
    categoryLinks() {
      return faqCategories.map(category => ({ id: category.id, label: category.title }))
    },
    query() {
      return this.keyword.trim().toLocaleLowerCase()
    },
    // 題目與答案都比對，沒有符合題目的分類整個隱藏
    filteredCategories() {
      return faqCategories
        .map(category => ({
          ...category,
          items: category.items.filter(item => !this.query || `${item.q} ${item.a}`.toLocaleLowerCase().includes(this.query))
        }))
        .filter(category => category.items.length)
    },
    countText() {
      if (!this.query) return ''
      const count = this.filteredCategories.reduce((sum, category) => sum + category.items.length, 0)
      return `${count}件の質問が見つかりました`
    }
  }
}
</script>
